import React from 'react';
import '../scss/Product.scss';
import { useNavigate } from 'react-router-dom';
import ApiImage from '../ApiImage';
import { useCurrency } from '../../contexts/CurrencyContext';

const ProductCard = ({ title, cost, image, className, id }) => {
  const navigate = useNavigate();
  const { cny } = useCurrency();
  return (
    <div key={id} className={`product-card ${className}`} onClick={() => navigate(`/product/${id}`)}>
      <div className="product">
        <ApiImage path={image} />
      </div>
      <div className="title-container">
        <div className="title-amount">{cost.toLocaleString("ru-RU")} ¥</div>
        <div className="title-convert-amount">~ {Math.round(cost * cny).toLocaleString("ru-RU")} ₽</div>
      </div>
      <div className="title-name">{title}</div>
    </div>
  )
}

export default ProductCard;
